import React from 'react'

interface LocationValueProps {
  label?: string
  value: string
  action: () => void
}

const LocationValue: React.ComponentType<LocationValueProps> = ({ value, label, action }) => {
  return (
    <div className="flex flex-col">
      {label && <p className="mb-1 block text-sm font-medium text-gray-700">{label}</p>}

      <div className="flex w-full">
        <p className="input bg-gray-50  py-2 px-2 text-sm font-normal leading-5 text-gray-500">{value}</p>

        <button type="button" className="btn btn-delete ml-3 self-start" onClick={action}>
          Remove
        </button>
      </div>
    </div>
  )
}

export default LocationValue
